module.exports = __webpack_public_path__ + "img/Feature.8578c17c.png";